import { render } from "./newFeed.vue?vue&type=template&id=512ab172"
import script from "./newFeed.vue?vue&type=script&lang=js"
export * from "./newFeed.vue?vue&type=script&lang=js"

import "./newFeed.vue?vue&type=style&index=0&id=512ab172&lang=css"
script.render = render

export default script